import HomeGameTeaserItem, {
  HomeGameTeaserItemVariant,
} from '@/components/HomeGameTeaserItem';
import Modal, {
  ModalContent,
  ModalHeader,
  ModalProps,
} from '@/components/Modal';
import { GameSwitchList } from '@/helpers/getGameLink';
import React from 'react';

interface ModalGameSwitchState {
  showSwitch: boolean;
}

interface ModalGameSwitchProps extends ModalProps {
  gameSwitch: GameSwitchList;
  currentGame: number;
}

class ModalGameSwitch extends React.Component<
  ModalGameSwitchProps,
  ModalGameSwitchState
> {
  constructor(props) {
    super(props);
    this.state = { showSwitch: false };
  }

  componentDidMount(): void {
    this.setState({ showSwitch: this.gameList.length > 0 });
  }

  private get gameList(): GameSwitchList {
    const { gameSwitch, currentGame } = this.props;
    return gameSwitch.filter((game) => game.id !== currentGame);
  }

  private get teaserVariant(): HomeGameTeaserItemVariant {
    switch (this.gameList.length) {
      case 1:
        return HomeGameTeaserItemVariant.Full;
      default:
        return HomeGameTeaserItemVariant.Half;
    }
  }

  render(): JSX.Element {
    const { id } = this.props;
    return (
      <Modal id={id} wide={true}>
        <ModalHeader>
          <span>Lotterie wechseln</span>
        </ModalHeader>
        <ModalContent>
          <div className="Modal__grid">
            {this.state.showSwitch
              ? this.gameList.map((game) => (
                  <HomeGameTeaserItem
                    key={game.id}
                    game={game.id}
                    href={game.path}
                    variant={this.teaserVariant}
                  />
                ))
              : null}
          </div>
        </ModalContent>
      </Modal>
    );
  }
}

export default ModalGameSwitch;
